// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login.js';
import Contract from './pages/Contract';
import Check from './pages/Check';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
function App() {
  const location = window.location.pathname;
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/dashboard" element={<ProtectedRoute component={Contract} />} />
          {/* <Route path="/contract/:id?" element={<ProtectedRoute component={Contract} />} /> */}
          <Route path="*" element={<Navigate to="/login" />} />


          <Route path="/authentication" element={<Check />} />

        </Routes>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;

function ProtectedRoute({ component: Component }) {
  const token = localStorage.getItem("token"); // Kendi token adını kullandığın için burada "token"
  return token ? <Component /> : <Navigate to="/login" replace />;
}